<script setup lang="ts">
import type { SuggestionProps } from "@tiptap/suggestion";
import MenuEmpty from "ls/components/primitives/menu/MenuEmpty.vue";
import { useAuth } from "ls/features/user/useAuth";
import { CanvasLinkNodeName } from "../links/canvas/types";
import SuggestionList from "../suggestions/SuggestionList.vue";
import { useProvideMentionSuggestionContext } from "./context";
import SectionSuggestions from "./SectionSuggestions.vue";
import UserSuggestions from "./UserSuggestions.vue";

const props = defineProps<SuggestionProps>();

const { user } = useAuth();
const {
  onKeyDown,
  onBeforeExit,
  noResults,
} = useProvideMentionSuggestionContext();

const suggestSections = props.editor.schema.nodes[CanvasLinkNodeName] !== undefined;

defineExpose({
  onKeyDown,
  onBeforeExit,
});
</script>

<template>
  <SuggestionList
    v-bind="$props"
  >
    <div class="grid grid-cols-[auto_auto_1fr_auto]">
      <UserSuggestions v-bind="props" />
      <SectionSuggestions v-if="suggestSections" v-bind="props" />
      <MenuEmpty v-if="user && noResults" />
    </div>
  </SuggestionList>
</template>
